import { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { useParams } from "react-router-dom";
import UserData from "../Controls/UserData";
import API from "@src/API.js";
import EmployerEditModal from "../Modals/EmployerEditModal";

function formatOpenDate(value) {
  if (!value) return "—";
  const dt = DateTime.fromISO(value);
  return dt.isValid ? dt.toFormat("MM/yyyy") : "—";
}

export default function EmployerBrief(props) {
  const params = useParams();
  const employerId = Number(props.ID ?? params.id ?? 0) || 0;

  const [employer, setEmployer] = useState(() => {
    if (!employerId) return null;
    const list = UserData.UserData()?.employers || [];
    return list.find((e) => Number(e.id ?? e.ID) === employerId) || null;
  });
  const [loading, setLoading] = useState(!employer && employerId > 0);
  const [showEdit, setShowEdit] = useState(false);

  useEffect(() => {
    if (!employerId) return undefined;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const resp = await API.getAsync(`/Employer/${employerId}`);
        if (!cancelled && resp?.ok && resp.jsonData) {
          setEmployer(resp.jsonData);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [employerId]);

  if (!employerId) {
    return <div className="mobileCard">No employer selected</div>;
  }

  if (loading && !employer) {
    return <div className="mobileCard">Loading employer…</div>;
  }

  if (!employer) {
    return <div className="mobileCard">Employer #{employerId} not found</div>;
  }

  const name =
    !employer.ShortName || employer.ShortName === ""
      ? employer.Name || employer.name
      : employer.ShortName;
  const fullName = employer.Name || employer.name || name;
  const url = employer.Url || employer.url || "";
  const description = employer.Description || employer.description || "";

  async function refreshAfterEdit() {
    setShowEdit(false);
    const resp = await API.getAsync(`/Employer/${employerId}`);
    if (resp?.ok && resp.jsonData) {
      setEmployer(resp.jsonData);
    }
  }

  return (
    <div className="mobileCard">
      <div className="header">Employer - {name}</div>
      <div className="body">
        <div>
          <div className="label">Name: </div>
          <span className="helpLink" onClick={() => setShowEdit(true)}>
            {fullName}
          </span>
        </div>
        <div>
          <div className="label">Open Date: </div>
          {formatOpenDate(employer.OpenDate || employer.openDate)}
        </div>
        <div>
          <div className="label">Url: </div>
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {url}
            </a>
          ) : (
            "—"
          )}
        </div>
        <div>
          <div className="label">Description:</div>
          {description || "—"}
        </div>
      </div>
      {showEdit ? (
        <EmployerEditModal employerId={employerId} onClose={refreshAfterEdit} />
      ) : null}
    </div>
  );
}
